<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstformaspagamento"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstformaspagamento.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>

                                <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbativo">Ativo:</label>
                                <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipo">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">À Vista</option>
                                    <option value="1">À Prazo</option>
                                    <option value="2">Cartão débito</option>
                                    <option value="3">Cartão crédito</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbespecie">Espécie:</label>
                                <select class="form-control form-control-sm" id="cbespecie" v-model="vespecie"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>

                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Bandeira:</span>
                                <select id="cbbandeira" v-model="vidbandeira" v-bind:disabled="ativadesativa"
                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                    style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbindicefiscal">Índice Fiscal:</label>
                                <select class="form-control form-control-sm" id="cbindicefiscal" v-model="vindicefiscal"
                                    v-bind:disabled="ativadesativa">
                                    <option value="01">01 - Dinheiro</option>
                                    <option value="02">02 - Cheque</option>
                                    <option value="03">03 - Cartão de Crédito</option>
                                    <option value="04">04 - Cartão de Débito</option>
                                    <option value="05">05 - Crédito de Loja</option>
                                    <option value="10">10 - Vale Alimentação</option>
                                    <option value="11">11 - Vale Refeição</option>
                                    <option value="12">12 - Vale Presente</option>
                                    <option value="13">13 - Vale Combustível</option>
                                    <option value="14">14 - Duplicata Mercantil</option>
                                    <option value="15">15 - Boleto Bancário</option>
                                    <option value="16">16 - Depósito Bancário</option>
                                    <option value="17">17 - Pagamento Instantâneo (PIX)</option>
                                    <option value="18">18 - Transferência Bancária, Carteira Digital</option>
                                    <option value="19">19 - Programa de fidelidade, Cashback, Crédito Virtual</option>
                                    <option value="90">90 - Sem Pagamento</option>
                                    <option value="99">99 - Outros</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbabatecredito">Abate crédito:</label>
                                <select class="form-control form-control-sm" id="cbabatecredito" v-model="vabatecredito"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtef">TEF:</label>
                                <select class="form-control form-control-sm" id="cbespecie" v-model="vtef"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbmodalidadetef">Modalidade TEF:</label>
                                <select class="form-control form-control-sm" id="cbmodalidadetef" v-model="vmodalidadetef"
                                    v-bind:disabled="ativadesativa || parseInt(vtef) !== 1">
                                    <option value="0">Não definido</option>
                                    <option value="1">Cartão</option>
                                    <option value="2">Dinheiro</option>
                                    <option value="3">Cheque</option>
                                    <option value="4">Carteira vitual</option>
                                </select>
                            </div>                                                        
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipocartaotef">Tipo cartão TEF:</label>
                                <select class="form-control form-control-sm" id="cbtipocartaotef" v-model="vtipocartaotef"
                                    v-bind:disabled="ativadesativa || parseInt(vtef) !== 1">
                                    <option value="0">Não definido</option>
                                    <option value="1">Cartão crédito</option>
                                    <option value="2">Cartão débito</option>
                                    <option value="3">Voucher</option>
                                    <option value="4">Frota</option>
                                    <option value="5">Private label</option>
                                    <option value="6">Outros</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbmodalidadefintef">Modalidade TEF:</label>
                                <select class="form-control form-control-sm" id="cbmodalidadefintef" v-model="vmodalidadefintef"
                                    v-bind:disabled="ativadesativa || parseInt(vtef) !== 1">
                                    <option value="0">Não definido</option>
                                    <option value="1">A vista</option>
                                    <option value="2">Parcelado emissor</option>
                                    <option value="3">Parcelado estabelecimento</option>
                                    <option value="4">Pré datado</option>
                                    <option value="5">Crédito emissor</option>
                                </select>
                            </div>                                                                                           
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadformaspagamento',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstformaspagamento  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vativo              :  1,
                vtipo               :  0,
                vespecie            :  0,
                vidbandeira         : null,
                vtef                :  0,
                vindicefiscal       : "01",
                vabatecredito       : 0,
                vmodalidadetef  	: 0,
                vtipocartaotef		: 0,
                vmodalidadefintef	: 0,                

                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FORMAS DE PAGAMENTO',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and f.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.descricao) like upper(\''+this.pconteudo+'%\')';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaformaspagamento(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaformaspagamento(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                retorno.then(function (response) {
                    vself.lstformaspagamento = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstformaspagamento = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                this.vativo             =  1;
                this.vtipo              =  0;
                this.vespecie           =  0;
                this.vidbandeira        = null;
                this.vtef               =  0;
                this.vindicefiscal      = "01";
                this.vabatecredito      = 0;
                this.vmodalidadetef  	= 0;
                this.vtipocartaotef		= 0;
                this.vmodalidadefintef	= 0;                

                $('#cbbandeira').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.015Z.001Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE FORMA DE PAGAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstformaspagamento = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.015Z.002Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FORMA DE PAGAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.015Z.003Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FORMA PAGAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdselect2_def(){
                let vself = this;
                $("#cbbandeira").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbandeirascredito',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidbandeira = $("#cbbandeira").val();
                });

            },
            mtdigualarcampos(registro){

                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.vtipo               = registro.tipo;
                this.vativo              = registro.ativo;
                this.vespecie            = registro.especie;
                this.vtef                = registro.tef;
                this.vindicefiscal       = registro.indicefiscal;
                this.vabatecredito       = registro.abatecredito;
                this.vidbandeira         = parseInt(registro.idbandeira) === 0 ? null : registro.idbandeira;            

                if (parseInt(registro.idbandeira) > 0){
                    var defbandeira = new Option(registro.descricaobandeira, this.vidbandeira, true, true);
                    $('#cbbandeira').append(defbandeira).trigger('change');
                }else{
                    $('#cbbandeira').val(null).trigger('change');
                }

                setTimeout(() => {
                    this.vmodalidadetef  	 = registro.modalidadetef;
                    this.vtipocartaotef		 = registro.tipocartaotef;
                    this.vmodalidadefintef	 = registro.modalidadefintef;   
                }, 200);

            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'tipo'              : this.vtipo,
                    'ativo'             : this.vativo,
                    'especie'           : this.vespecie,
                    'tef'               : this.vtef,
                    'indicefiscal'      : this.vindicefiscal,
                    'abatecredito'      : this.vabatecredito,
                    'idbandeira'        : this.vidbandeira === null ? 0 : this.vidbandeira,
                    'modalidadetef'  	: this.vmodalidadetef,
                    'tipocartaotef'	    : this.vtipocartaotef,
                    'modalidadefintef'	: this.vmodalidadefintef
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.015Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.015Z.002Z' : '001Z.015Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaformaspagamento(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('001Z.015Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaformaspagamento(val);
            },
            vtef(){
                this.vmodalidadetef  	= 0;
                this.vtipocartaotef		= 0;
                this.vmodalidadefintef	= 0;  
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
</style>